module.exports = __webpack_public_path__ + "static/media/Turning Clunkers into Cash.ec3d7fd7.jpg";